import { connect } from 'react-redux';
import { actions as userActions } from '../../../redux/users';
import { hideComment, reportComment, unhideComment, featureComment, unfeatureComment } from '../../redux/actionCreators';
import { isCommentReduxReady } from '../../redux/selectors';
const mapStateToProps = (state)=>({
        isCommentReduxReady: isCommentReduxReady(state)
    });
const mapDispatchToProps = {
    onReportSpam: reportComment,
    onHide: hideComment,
    onUnhide: unhideComment,
    onFeature: featureComment,
    onUnfeature: unfeatureComment,
    onBlockUser: userActions.blockUser
};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=ActionsMenu.container.js.map